.ssoButton {
  border: 1px solid var(--mantine-color-gray-2);
  background-color: white;
  color: var(--mantine-color-gray-10);

  &:hover {
    background-color: var(--mantine-color-gray-2);
    color: var(--mantine-color-gray-10);
  }

  &:disabled {
    background-color: var(--mantine-color-gray-3);
  }

  &:active {
    background-color: var(--mantine-color-gray-2);
  }
}

.ssoButtonDestructive {
  border: 1px solid var(--mantine-color-red-2);
  background-color: white;
  color: var(--mantine-color-red-7);

  &:hover {
    background-color: var(--mantine-color-red-1);
    color: var(--mantine-color-red-8);
  }

  &:disabled {
    background-color: var(--mantine-color-gray-3);
    color: var(--mantine-color-gray-6);
  }

  &:active {
    background-color: var(--mantine-color-red-2);
  }
}
